import DropdownVariations from "gatsby-theme-dettol/src/components/DropdownVariations/DropdownVariations"

import "./DropdownVariationsOverride.scss"

export default DropdownVariations